import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="hairline-grid bg-parchment" data-testid="not-found-page">
      <div className="container-x py-28">
        <p className="eyebrow">404</p>
        <h1 className="mt-6 font-display text-5xl font-semibold text-navy sm:text-6xl">This page isn't in the ledger.</h1>
        <Link to="/" className="btn-primary mt-10" data-testid="not-found-home-button">Return home</Link>
      </div>
    </section>
  );
}
